<script setup>
import { reactive, ref } from 'vue'

defineProps({
  content: { type: Object, required: true },
  variant: { type: String, default: 'contact-01' },
})

const form = reactive({ name: '', email: '', service: '', message: '' })
const formSent = ref(false)

function submitForm(e) {
  e.preventDefault()
  formSent.value = true
}
</script>

<template>
  <section id="contact" class="b2-contact" :class="`variant-${variant}`">
    <div class="b2-contact-left">
      <div class="b2-section-label">{{ content.label.value }}</div>
      <h2 class="b2-section-title">{{ content.title.value }}</h2>
      <p>{{ content.sub.value }}</p>
      <ul class="b2-contact-info">
        <li><v-icon>mdi-email-outline</v-icon> {{ content.email.value }}</li>
        <li v-if="content.phone.value"><v-icon>mdi-phone-outline</v-icon> {{ content.phone.value }}</li>
        <li v-if="content.hours.value"><v-icon>mdi-clock-time-eight-outline</v-icon> {{ content.hours.value }}</li>
      </ul>
    </div>
    <div class="b2-contact-right">
      <form class="b2-contact-form" @submit="submitForm">
        <div class="b2-form-row">
          <div class="b2-form-group">
            <label>Full Name</label>
            <input v-model="form.name" type="text" placeholder="Jane Smith" required />
          </div>
          <div class="b2-form-group">
            <label>Email</label>
            <input v-model="form.email" type="email" placeholder="jane@example.com" required />
          </div>
        </div>
        <div class="b2-form-group">
          <label>Message</label>
          <textarea v-model="form.message" rows="4" placeholder="Tell us about your project..."></textarea>
        </div>
        <button type="submit" class="b2-btn-primary b2-btn-full">
          {{ formSent ? '✓ Message Sent!' : 'Send Message' }}
        </button>
      </form>
    </div>
  </section>
</template>

<style scoped>
.b2-contact { padding: 100px 40px; display: grid; grid-template-columns: 1fr 1.4fr; gap: 80px; max-width: 1200px; margin: 0 auto; align-items: start; }
@media (max-width: 768px) { .b2-contact { grid-template-columns: 1fr; gap: 40px; padding: 60px 20px; } }
.b2-section-label { font-size: 11px; font-weight: 500; letter-spacing: .2em; text-transform: uppercase; color: #4a8c3f; margin-bottom: 14px; }
.b2-section-title { font-family: 'Playfair Display', serif; font-size: clamp(30px, 4vw, 50px); font-weight: 700; color: #1a3320; line-height: 1.15; margin-bottom: 16px; }
.b2-contact-left p { font-size: 16px; color: #555; line-height: 1.7; margin-bottom: 28px; }
.b2-contact-info { list-style: none; display: flex; flex-direction: column; gap: 12px; }
.b2-contact-info li { font-size: 15px; color: #444; }
.b2-contact-form { display: flex; flex-direction: column; gap: 18px; background: #f5f9f4; padding: 36px; border-radius: 4px; }
.b2-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; }
@media (max-width: 480px) { .b2-form-row { grid-template-columns: 1fr; } }
.b2-form-group { display: flex; flex-direction: column; gap: 6px; }
.b2-form-group label { font-size: 11px; font-weight: 500; letter-spacing: .1em; text-transform: uppercase; color: #555; }
.b2-form-group input, .b2-form-group textarea { width: 100%; padding: 11px 14px; border: 1.5px solid #d4e8d0; border-radius: 2px; font-family: 'DM Sans', sans-serif; font-size: 15px; background: white; color: #1a1a1a; transition: border-color .2s; resize: vertical; }
.b2-form-group input:focus, .b2-form-group textarea:focus { outline: none; border-color: #4a8c3f; }
.b2-btn-primary { background: #4a8c3f; color: white; padding: 14px 32px; border-radius: 2px; text-decoration: none; font-size: 14px; font-weight: 500; letter-spacing: .06em; text-transform: uppercase; border: none; cursor: pointer; }
.b2-btn-primary:hover { background: #3a6e30; }
.b2-btn-full { width: 100%; text-align: center; padding: 15px; font-size: 15px; }
.variant-contact-02 { max-width: none; padding-left: max(40px, calc((100% - 1120px) / 2)); padding-right: max(40px, calc((100% - 1120px) / 2)); background: #1a3320; color: white; }
.variant-contact-02 .b2-section-title { color: white; }
.variant-contact-02 .b2-contact-left p, .variant-contact-02 .b2-contact-info li { color: rgba(255,255,255,.72); }
.variant-contact-02 .b2-contact-form { background: rgba(255,255,255,.08); }
.variant-contact-02 .b2-form-group label { color: rgba(255,255,255,.72); }
.variant-contact-03 { display: block; text-align: center; }
.variant-contact-03 .b2-contact-left { max-width: 680px; margin: 0 auto 38px; }
.variant-contact-03 .b2-contact-info { flex-direction: row; justify-content: center; flex-wrap: wrap; }
.variant-contact-03 .b2-contact-right { max-width: 760px; margin: 0 auto; text-align: left; }
@media (max-width: 768px) {
  .variant-contact-02 { padding-left: 20px; padding-right: 20px; }
}
</style>
